/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import CommonQuickActionButtons from "../../../../components/_utils/CommonQuickActionButtons/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import Loader from "../../../../components/Loader/Index";
import BeneficiaryTransactionGridView from "../../../../components/Transactions/BeneficiaryTransaction/BeneficiaryTransactionGridView/index.jsx";
import {
  beneficiaryTransactionsViewAll,
  bulkTransactionsDetailsById,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useCategories from "../../../../utils/useCategories";
import BulkTransactionViewAll from "../BulkTransactionViewAll";

const BulkTransactionDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const categoryMapper = useCategories();
  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const [loader, setLoader] = useState(true);
  const [detaildata, setDetailData] = useState([]);
  const [mainLoader, setMainLoader] = useState(true);
  const [categoryPass, setcategoryPass] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [showCategorypopup, setShowCategoryPopup] = useState(false);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [index, setIndex] = useState(GlobalConfiguration.lengthCheckZero);
  const [currentPage, setCurrentPage] = useState(
    GlobalConfiguration.lengthCheckOne,
  );

  const categoryData = detaildata?.transaction_file?.category_id;

  const categoryIcon = categoryMapper(categoryData?.category_id);

  const categoryUndefined =
    detaildata?.transaction_file?.category_id?.category_id === undefined;

  const isFileProcessingFailed =
    detaildata?.transaction_file?.file_status === "failed" &&
    !detaildata?.transaction_file?.failed_transctions?.length;

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(Number(value));
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  const handleViewCategory = (categories) => {
    setShowCategoryPopup(true);
    setcategoryPass(categories);
  };

  const formatToCustom = (date) => {
    const optionsDate = { day: "numeric", month: "short", year: "numeric" };
    const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };

    const datePart = date.toLocaleDateString("en-GB", optionsDate);
    const timePart = date
      .toLocaleTimeString("en-GB", optionsTime)
      .toLowerCase();

    return `${datePart}, ${timePart}`;
  };

  const BACKEND_BATCH_SIZE = 30;

  const totalSuccessCount =
    detaildata?.transaction_file?.transctions_ids?.length ||
    GlobalConfiguration.lengthCheckZero;

  const handleFetch = async () => {
    setLoader(true);
    try {
      const transactionIds =
        detaildata?.transaction_file?.transctions_ids || [];
      if (!transactionIds.length) {
        setTransactionData({ transactions: [] });
        return;
      }
      const uiPageSize = Number(pageSize);

      const uiStartIndex = (currentPage - 1) * uiPageSize;

      const currentPageIds = transactionIds.slice(
        uiStartIndex,
        uiStartIndex + uiPageSize,
      );

      // Split into backend-safe batches of 30
      const batches = [];

      for (
        let index = 0;
        index < currentPageIds.length;
        index += BACKEND_BATCH_SIZE
      ) {
        batches.push(currentPageIds.slice(index, index + BACKEND_BATCH_SIZE));
      }

      const responses = await Promise.all(
        batches.map((batch) =>
          dispatch(
            beneficiaryTransactionsViewAll({
              page_no: 1,
              page_item_count: batch.length,
              txn_id: batch,
            }),
          ).unwrap(),
        ),
      );

      const mergedTransactions = responses.flatMap(
        (response) => response?.transactions || [],
      );

      const firstResponse = responses[0] || {};
      const mergedResponse = {
        ...firstResponse,
        transactions: mergedTransactions,
        payload: {
          ...firstResponse?.payload,
          transactions: mergedTransactions,
          total_count: totalSuccessCount,
          title: {
            ...firstResponse?.payload?.title,
            records: totalSuccessCount,
            total_pages: Math.max(
              Math.ceil(totalSuccessCount / uiPageSize),
              GlobalConfiguration.lengthCheckOne,
            ),
            current_page: currentPage,
            page_item_count: uiPageSize,
          },
        },
      };
      setTransactionData(mergedResponse);
    } catch (error) {
      setTransactionData({ transactions: [] });
      CommonToast({
        text: error?.message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setMainLoader(true);
    const fetchData = async () => {
      let response = await dispatch(bulkTransactionsDetailsById({ id }));

      if (response?.payload?.errors?.user_unauthorized?.length) {
        return navigate("/feature_not_assigned", {
          state: { unavailableService: "VTransactionUpload" },
        });
      }

      setDetailData(response?.payload);
      setMainLoader(false);
      setShowCategoryPopup(false);
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const hasSuccess =
      (detaildata?.transaction_file?.transctions_ids?.length ??
        GlobalConfiguration.lengthCheckZero) >
      GlobalConfiguration.lengthCheckZero;

    const hasFailed =
      (detaildata?.transaction_file?.failed_transctions?.length ??
        GlobalConfiguration.lengthCheckZero) >
      GlobalConfiguration.lengthCheckZero;

    if (hasFailed) {
      setIndex(GlobalConfiguration.lengthCheckOne);
    } else if (hasSuccess) {
      setIndex(GlobalConfiguration.lengthCheckZero);
    }
  }, [detaildata]);

  useEffect(() => {
    if (detaildata?.status) {
      handleFetch();
    }
  }, [detaildata, currentPage, selectedValue]);

  return (
    <div className="h-screen w-full flex flex-col bg-primary-bg overflow-hidden ">
      {mainLoader ? (
        <div className="absolute top-top-base z-z-index-fixed-ui h-height-full w-width-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <>
          <div className="bg-primary-nav h-[var(--min-height-secondary-edge-fill-btn)] Qsmd:h-navbar-breadcrumb-height flex Qsmd:flex-shrink-0"></div>
          <div
            ref={scrollContainerRef}
            className="flex flex-col overflow-y-auto overflow-x-hidden flex-1 scroll-py-top_md"
          >
            {showCategorypopup && (
              <div className="z-z-index-modal fixed top-top-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
                <LargePopupRedirect
                  headerTitle="Bulk transactions view all"
                  closeiconisLoading={false}
                  closeiconhandleFunction={() => setShowCategoryPopup(false)}
                  closeicon={ICONS?.CLOSE}
                  closeiconhoverOption="white"
                  closeiconbtnType={"button"}
                  closeiconisDisabled={false}
                  closeicondisabledBgColor={""}
                  closeiconbuttonRef={null}
                  closeicontitle={"Close"}
                  type={"BulkUploadDetails"}
                >
                  <BulkTransactionViewAll
                    popType={"BulkUploadDetails"}
                    categoryPass={categoryPass}
                  />
                </LargePopupRedirect>
              </div>
            )}
            <div className="min-h-mobile-navbar-height bg-primary-nav-act p-padding-md fixed top-top-base z-z-index-fixed-ui Qsmd:min-h-height-base Qsmd:bg-transparent Qsmd:p-padding-base Qsmd:static Qsmd:z-auto">
              <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
                <TopNavComponent
                  topNavHeader={globalText?.BENEFICIARY_TRANSACTIONS}
                  isFormattingNotRequired
                  topNavSubText="Bulk transaction detail"
                  handleBack={() => {
                    navigate(GlobalConfiguration.navigate_back);
                  }}
                />
              </div>
            </div>
            <div className="w-width-full bg-primary-nav h-fit">
              <div className="w-width-full my-margin-base mx-auto max-w-tab-width-normal h-fit flex flex-col overflow-hidden px-padding-md Qlg:px-padding-base">
                <div className="h-fit relative py-padding-sm px-padding-base Qsmd:py-padding-md">
                  <div className="h-fit flex flex-col gap-y-gap-sm Qsmd:flex-row Qsmd:gap-x-gap-md Qsmd:ml-margin-md lg:ml-margin-base">
                    <div className="flex flex-1 flex-col h-fit w-width-full max-w-max_width-full Qsmd:w-auto Qsmd:max-w-column-width-lg py-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={detaildata?.transaction_file?.file_name}
                        titleColor="text-primary "
                        subtitle={"File name"}
                        alignRight={false}
                        hoverOption="white"
                        isBold={false}
                        variant="md"
                      />
                    </div>

                    <div className="border-r-border border-t-border border-primary-bg Qsmd:border-t-border-base"></div>
                    <div className="flex flex-1 flex-col h-fit w-width-full max-w-max_width-full Qsmd:w-auto Qsmd:max-w-column-width-lg py-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={
                          detaildata?.transaction_file?.file_status ===
                          "processed"
                            ? detaildata?.transaction_file?.failed_transctions
                                ?.length +
                                detaildata?.transaction_file?.transctions_ids
                                  ?.length ||
                              GlobalConfiguration.lengthCheckZero
                            : "NA"
                        }
                        titleColor="text-primary "
                        subtitle={"Total transactions"}
                        alignRight={false}
                        hoverOption="white"
                        isBold={false}
                        variant="md"
                      />
                    </div>
                    <div className="border-r-border border-t-border border-primary-bg Qsmd:border-t-border-base"></div>
                    <div className="flex flex-1 flex-col h-fit w-width-full max-w-max_width-full Qsmd:w-auto Qsmd:max-w-column-width-lg py-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={detaildata?.transaction_file?.file_status
                          ?.toLowerCase()
                          ?.replace(/^\w/, (c) => c.toUpperCase())}
                        titleColor={
                          detaildata?.transaction_file?.file_status ===
                          "processed"
                            ? "settled"
                            : detaildata?.transaction_file?.file_status ===
                                "failed"
                              ? "failed"
                              : "queued"
                        }
                        subtitle={"Status"}
                        alignRight={false}
                        hoverOption="white"
                        isBold={false}
                        variant="md"
                      />
                    </div>
                    <div className="hidden Qsmd:flex flex-col justify-center items-center absolute top-top-base right-right-base h-height-full w-splitview-btn-width px-padding-sm bg-primary-nav-act">
                      <TopNavSmallButton
                        btnText={
                          detaildata?.transaction_file?.category_id
                            ?.category_name || "Not given"
                        }
                        handleFunction={() =>
                          handleViewCategory(
                            detaildata?.transaction_file?.category_id,
                          )
                        }
                        // isDisabled={categoryUndefined && "none"}
                        enabledTextColor="var(--text-secondary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="transparent"
                        icon={categoryIcon.url}
                        imgColor={categoryIcon?.colour}
                        hoverOption="white"
                        fullWidthRequired={false}
                        isBackgroundRequired={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="border-t border-primary-bg"></div>
                <div className="h-fit relative py-padding-sm px-padding-base Qsmd:py-padding-md">
                  <div className="h-fit flex flex-col gap-y-gap-sm Qsmd:flex-row Qsmd:gap-x-gap-md Qsmd:ml-margin-md lg:ml-margin-base">
                    <div className="flex flex-1 flex-col h-fit w-width-full Qsmd:w-auto pb-padding-sm Qmd:pb-padding-base">
                      <TitleSubtitlePair
                        title={formatToCustom(
                          new Date(detaildata?.transaction_file?.created_at),
                        )}
                        titleColor={"text-primary"}
                        subtitle={"Date and time"}
                        alignRight={false}
                        hoverOption="white"
                        isBold={false}
                        variant="md"
                      />
                    </div>
                    <div className="border-r-border border-t-border border-primary-bg Qsmd:border-t-border-base"></div>
                    <div className="flex flex-1 flex-col h-fit w-width-full Qsmd:w-auto pt-padding-sm Qmd:py-padding-base">
                      <TitleSubtitlePair
                        title={detaildata?.transaction_file?.uploaded_by}
                        titleColor={"text-primary"}
                        subtitle={"Uploaded by"}
                        alignRight={false}
                        hoverOption="white"
                        isBold={false}
                        variant="md"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="Qsmd:mt-margin-base mt-margin-md">
              {!categoryUndefined && (
                <div className="block Qsmd:hidden">
                  <CommonQuickActionButtons
                    title="Quick Actions"
                    actions={[
                      {
                        key: "view-category",
                        btnText:
                          detaildata?.transaction_file?.category_id
                            ?.category_name || "",
                        handleFunction: () =>
                          handleViewCategory(
                            detaildata?.transaction_file?.category_id,
                          ),
                        icon: categoryIcon.url,
                        imgColor: categoryIcon?.colour,
                        isBackgroundRequired: true,
                      },
                    ]}
                  />
                </div>
              )}
            </div>

            {isFileProcessingFailed ? (
              <div className="w-width-full max-w-tab-width-normal mt-margin-md mx-auto px-padding-md Qlg:px-padding-base h-fit">
                <div className="h-height-full rounded-border-radius-md py-padding-md px-padding-md bg-primary-card flex flex-col gap-x-gap-md">
                  <div className="flex ">
                    <img
                      className="h-icon-md w-icon-md my-auto "
                      src={ICONS?.ALERT}
                      alt=""
                    />
                    <p className="font-normal ml-margin-sm text-font-sm h-fit text-text-primary">
                      Unable to Process File
                    </p>
                  </div>
                  <div className="h-fit flex mt-margin-sm flex-col gap-x-gap-sm">
                    <p className="font-normal text-font-sm h-fit text-text-primary">
                      Unable to process the uploaded transaction file. Check the
                      file and try uploading it again.
                    </p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="relative bg-primary-bg w-full-width h-full flex flex-col z-z-index-content">
                <div
                  className={`w-width-full bg-primary-act h-fit fixed z-z-index-fixed-ui ${
                    index === GlobalConfiguration?.lengthCheckZero
                      ? "bottom-bottom-label-tab pb-padding-sm"
                      : "bottom-bottom-base"
                  }`}
                >
                  <div className="z-z-index-header bg-primary-act w-width-full max-w-tab-width-normal p-padding-sm my-margin-base mx-auto flex flex-col justify-between gap-y-gap-xs h-fit Qsmd:flex-row">
                    <p className="font-normal text-font-sm h-fit text-text-primary">
                      {index === GlobalConfiguration?.lengthCheckZero ? (
                        <>
                          Transactions created -
                          <span className="text-settled">
                            {
                              detaildata?.transaction_file?.transctions_ids
                                ?.length
                            }
                          </span>
                        </>
                      ) : (
                        <>
                          Transactions failed -
                          <span className="text-failed">
                            {
                              detaildata?.transaction_file?.failed_transctions
                                ?.length
                            }
                          </span>
                        </>
                      )}
                    </p>
                    <div className="h-fit flex flex-col gap-y-gap-sm Qsmd:flex-row Qsmd:gap-x-gap-sm">
                      <p className="font-normal text-font-sm h-fit text-text-primary">
                        {index === GlobalConfiguration?.lengthCheckZero
                          ? "The above transactions has been created and sent for approval."
                          : "Fix the errors, and upload the corrected data as a new file."}
                      </p>
                    </div>
                  </div>
                </div>

                {index === GlobalConfiguration?.lengthCheckZero && (
                  <div className="fixed z-z-index-fixed-ui w-width-full bottom-bottom-base h-pagination-height">
                    <PaginationComponent
                      handleSelect={handleSelect}
                      selectedValue={selectedValue}
                      data={{
                        ...transactionData?.payload,
                        total_count: totalSuccessCount,
                        title: {
                          ...transactionData?.payload?.title,
                          records: totalSuccessCount,
                          total_pages: Math.max(
                            Math.ceil(totalSuccessCount / Number(pageSize)),
                            GlobalConfiguration.lengthCheckOne,
                          ),
                          current_page: currentPage,
                          page_item_count: Number(pageSize),
                        },
                      }}
                      pageSize={pageSize}
                      dropdownOptions={dropdownOptions}
                      handlePagination={handlePagination}
                      currentPage={currentPage}
                      setIsOpen={() => {}}
                    />
                  </div>
                )}

                <div className="w-width-full bg-primary-bg px-padding-base lg:px-padding-base pt-padding-md">
                  <div className="h-fit mx-auto ml-margin-md Qsmd:ml-auto max-w-tab-width-normal flex gap-x-gap-base Qsmd:gap-x-gap-md bg-primary-bg w-width-full">
                    <SwitcherTabs
                      tabs={[
                        {
                          label: "Successful transactions",
                          key: "Success transactions",
                          handler: () =>
                            setIndex(GlobalConfiguration.lengthCheckZero),
                          isDisabled:
                            !detaildata?.transaction_file?.transctions_ids
                              ?.length,
                        },
                        {
                          label: "Failed transactions",
                          key: "Failed transactions",
                          handler: () =>
                            setIndex(GlobalConfiguration.lengthCheckOne),
                          isDisabled:
                            !detaildata?.transaction_file?.failed_transctions
                              ?.length,
                        },
                      ]}
                      swicherTabBgColor={"var(--primary-card)"}
                      setIndex={setIndex}
                      initialActiveTab={
                        detaildata?.transaction_file?.failed_transctions?.length
                          ? "Failed transactions"
                          : "Success transactions"
                      }
                    />
                  </div>
                </div>

                {index === GlobalConfiguration?.lengthCheckZero && (
                  <>
                    {loader ? (
                      <div className="absolute top-top-base flex-1 z-z-index-fixed-ui opacity-dark-opacity h-height-full w-width-full flex justify-center items-center bg-PopUp-BackDrop">
                        <div className="flex flex-col items-center">
                          <Loader />
                          <p className="text-font-sm h-fit text-text-primary font-semibold tracking-letter-space">
                            Verifying data
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="flex-1 flex flex-col">
                        <BeneficiaryTransactionGridView
                          data={transactionData?.transactions || []}
                          typepop="Bulk"
                          onClose={() => {}}
                          currentStatus=""
                          filterRef={scrollContainerRef}
                        />
                      </div>
                    )}
                  </>
                )}

                {index === GlobalConfiguration?.lengthCheckOne && (
                  <div className="flex flex-col mb-margin-xl pb-padding-xl pt-padding-md">
                    <div className="z-z-index-header w-width-full flex bg-primary-nav-act">
                      <div className="w-column-width-sm text-center py-padding-base px-padding-md">
                        <p className="text-font-xs py-padding-md text-text-secondary">
                          Row no.
                        </p>
                      </div>
                      <div className="border-r border-primary-bg"></div>
                      <div className="flex-1 text-left py-padding-base px-padding-md">
                        <p className="text-font-xs py-padding-md h-icon-sm text-text-secondary">
                          Error message
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      {detaildata?.transaction_file?.failed_transctions?.map(
                        (data) => (
                          <div
                            key={data?.row_number}
                            className="flex h-fit relative overflow-x-hidden py-padding-sm border-b border-primary-nav-act last:border-b-0 last:mb-margin-sm after:absolute after:content-[''] after:bottom-bottom-base after:w-width-full after:border-b-border after:border-primary-bg last:after:border-b-0"
                          >
                            <div className="flex items-center w-column-width-sm py-padding-sm px-padding-md justify-center h-auto">
                              <p className="text-font-xs h-fit text-text-secondary">
                                {data?.row_number || "–"}
                              </p>
                            </div>
                            <div></div>
                            <div className="flex items-center w-column-width-sm py-padding-sm px-padding-md justify-start flex-1 h-fit">
                              <p className="text-font-xs break-all h-fit text-text-secondary">
                                {data?.error}
                              </p>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
      {index === GlobalConfiguration?.lengthCheckZero &&
        !mainLoader &&
        !loader &&
        !isFileProcessingFailed && (
          <div>
            <div className="h-pagination-height flex-shrink-0 mt-margin-xs pt-padding-sm"></div>
            <div className="h-pagination-height flex-shrink-0"></div>
          </div>
        )}
    </div>
  );
};

export default BulkTransactionDetails;
